<template>
  <div class='familyMember'>
     <div class="explain">
        <img src="@/assets/img/equipment/topImg1.png" class="imgs">
        <!-- <div class="txt">管理其他家长<br><span>实现共同管理</span></div> -->
    </div>
     <div class="list">
       <div class="listCon flex-between"  v-for='(item,i) in list' :key='i' @click='gotoUrl("memberAdd",Object.assign({color:colors[getNum(i)]},item))'>
          <div>
            <div :class="'text bg'+getNum(i)" :style="'background:#'+colors[getNum(i)]">{{item.kinshipName.substring(0,1)}}</div>
            <div class='con'>
                <p class='tit font18 flex-between'><span>{{item.kinshipName}}</span>
                  <span class='role' v-if="item.isMaster==1">管理员</span>
                  <span class="mine" v-if="item.parentId==parentId">我</span>
                </p>
                <div class='tel font15'>{{item.parentPhone}}</div>
            </div> 
          </div>
          <p class='optBtn'><svg-icon icon-class="right"/></p>
       </div>
     </div>
     
    <div class='noData' v-if="text&&list.length==0"><div><img :src='require("@/assets/img/equipment/addressNodata.png")'><br />{{text}}</div></div>
    
    <div class="btn" v-if="isMaster==1&&channelCode=='esi'"> 
          <div class="btn-primary"  @click="gotoUrl('memberAdd')">添加家长</div>
    </div> 
    
  </div>
</template>
<script>
import {getParentInfoByStudentId} from "@/api/api.mine";
  export default {
    data() {
      return {
        list:'',
        isAdd:false,
        isMaster:this.$store.state.users.parent.isMaster,
        parentId:this.$store.state.users.parent.parentId,
        channelCode:this.$store.state.loginUser.channelCode,
        contractName:'',
        kinship:null,
        phone:'',
        sos:false,
        text:'',
        curData:'',
        colors:{0:'B7C5D2',2:'BBB2C7',4:'D3BFB8',6:'B7C6B3',8:'D2CAB3'},
      }
    },
   created(){
     this.getList();
    },
    methods: {
      getNum(i){
        let num=(i/5).toFixed(1).split('.');
        return num[1]
      },
       getList(){
         getParentInfoByStudentId({
              studentId:this.loginUser.studentId
           }).then((data) => {
            if (data && data.result) {
              this.list=data.result.parentList;
            }else{
              this.text='暂无数据';
            }
           })
       },
       
    },
  }
</script>
<style lang="scss" >
.familyMember{
    font-size:.14rem;
    padding:.12rem .12rem 1rem;
    .explain{
      position: relative;
      .imgs{
          width: 100%;
        }
        // .txt{
        //   color:#0653BF;
        //   font-size: .14rem;
        //   position: absolute;
        //   top: .12rem;
        //   left: .12rem;
        //   line-height: .2rem;
        //   span{
        //     font-size: .12rem;
        //     opacity: .6;
        //   }
        // }
    }
  .list{
    margin:.12rem auto;
    border-radius: .1rem;
    background: #fff;
    .listCon{
      position: relative;
      padding:.16rem .12rem;
      display: flex;
      align-items: center;
      &::after{
        content:'';
        width: calc(100% - .62rem);
        height: 1px;
        background: #DCDCDC;
        display: block;
        position: absolute;
        right: 0px;
        bottom: 0px;
      }
      &:last-child{
        &::after{
          display: none;
        }
      }
      .text{
        width:.5rem;
        height:.5rem;
        border-radius:50%;
        margin-right: .1rem;
        line-height: .5rem;
        font-size: .18rem;
        text-align: center;
        display: inline-block;
        color: #fff;
        background: #B7C5D2;
        vertical-align:top;
       
      }
      .con{
          display: inline-block;
          color: rgba(0,0,0,.9);
          .role{
            background: #FF6430;
            color:#fff;
            border-radius:3px;
            padding:.02rem .05rem;
            font-size: .1rem;
            margin-left:.04rem;
          }
          .mine{
            background:#4BC12D;
            padding:.02rem .05rem;
            color: #fff;
            margin-left: 8px;
            font-size: .1rem;
            border-radius: 2px;
          }
          .tel{
            padding-top: .07rem;
            font-size: .15rem;
            color:rgba(0,0,0,.6)
          }
      }
     
    }
    
  }
  .btn{
        position: fixed;
        bottom:0rem;
        padding: .2rem .2rem .48rem;
        text-align: center;
        width: 100%;
        left:0;
        background:#f4f7fd;
        z-index: 1;
    } 
}

</style>